import { ReactElement, useMemo } from 'react';
import { Table } from 'antd';

import { ReadonlyBandsTableProps } from './interfaces';
import styles from './styles.module.css';

export const ReadonlyBandsTable = <T extends object>({ columns, dataSource }: ReadonlyBandsTableProps<T>): ReactElement => {
  // Bands carry no id of their own, and a read-only table never reorders them, so the position is a stable key.
  const rowKeys = useMemo(() => new Map(dataSource.map((band, index) => [band, String(index)])), [dataSource]);

  return (
    <Table<T>
      className={styles.table}
      size="small"
      tableLayout="fixed"
      pagination={false}
      rowHoverable={false}
      columns={columns}
      dataSource={dataSource}
      rowKey={band => rowKeys.get(band) ?? ''}
    />
  );
};
